import { render } from "./OrdersList.vue?vue&type=template&id=f19fbc6a&scoped=true&ts=true"
import script from "./OrdersList.vue?vue&type=script&lang=ts"
export * from "./OrdersList.vue?vue&type=script&lang=ts"

import "./OrdersList.vue?vue&type=style&index=0&id=f19fbc6a&scoped=true&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f19fbc6a"]])

export default __exports__